export type WorkflowOutcome<T = void> = { ok: true; value: T } | { ok: false; error: unknown };

export const succeed = <T>(value: T): WorkflowOutcome<T> => ({ ok: true, value });

export const fail = (error: unknown): WorkflowOutcome<never> => ({ ok: false, error });

export const outcomeValue = <T>(outcome: WorkflowOutcome<T>): T => {
  if (!outcome.ok) throw outcome.error;
  return outcome.value;
};

/** Runs an operation and turns its result or its error into an outcome. */
export async function attempt<T>(run: () => Promise<T>): Promise<WorkflowOutcome<T>> {
  try {
    return succeed(await run());
  } catch (error) {
    return fail(error);
  }
}
